import React from "react";

export const MarineSolutions = [
  <>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <h4 className="slideTitle">A transition to a zero-carbon future</h4>
        <p>
          <strong>Existing Vessels</strong>
        </p>
        <p>
          <strong>Avoid</strong>
        </p>
        <ul className="shell_bullets_list">
          <li>Using existing technologies to improve efficiency</li>
          <li>
            From draft optimisation and air lubrication to lubricant services
            and digital solutions
          </li>
        </ul>
        <p>
          <strong>Reduce</strong>
        </p>
        <ul className="shell_bullets_list">
          <li>Adopting low-emission fuels such as Biofuels (availability)</li>
          <li>LNG (availability)</li>
        </ul>
        <p>
          <strong>Compensate</strong>
        </p>
        <ul className="shell_bullets_list">
          <li>
            Balancing unavoidable emissions through nature-based solutions (NBS)
          </li>
        </ul>
        {/* <p>
        WE ARE COLLABORATING
        <br />
        With our customers, across our business, our sector and beyond to
        develop practical solutions that will speed progress to a zero-carbon
        future.
      </p> */}
      </div>
      <div className="colRight col50 solidColourContainer">
        <p>
          <strong>New Vessels</strong>
        </p>
        <p>
          <strong>Avoid</strong>
        </p>
        <ul className="shell_bullets_list">
          <li>Using existing technologies to improve efficiency</li>
          <li>
            From draft optimisation and air lubrication to lubricant services
            and digital solutions
          </li>
        </ul>
        <p>
          <strong>Reduce</strong>
        </p>
        <ul className="shell_bullets_list">
          <li>Investing in LNG vessels</li>
          <li>Adopting Biofuels, Bio-LNG</li>
          <li>
            Investing in future zero-carbon fuels such as Ammonia and Hydrogen
          </li>
        </ul>
        <p>
          <strong>Compensate</strong>
        </p>
        <ul className="shell_bullets_list">
          <li>
            Balancing unavoidable emissions through nature-based solutions (NBS)
          </li>
        </ul>
      </div>
    </div>
  </>,
  <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col50 backgroundImage">
      <img src="images/marineVessels.jpg" width="100%" height="auto" />
    </div>
    <div className="colRight col50 solidColourContainer stats">
      <p class="statsIntro">We are collabarating</p>
      <p>
        With our customers, across our business, our sector and beyond to
        develop practical solutions that will speed progress to a zero-carbon
        future.
      </p>
    </div>
  </div>,
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col50">
      <p class="statsIntro">LNG is the path to unlocking future fuels</p>
      <p>
        LNG will help advance the technology that unlocks super-low emission and
        net-zero fuels
      </p>
      <img src="images/marineTable.JPG" width="100%" height="auto" />
    </div>
    <div className="colRight col50 backgroundImage">
      <img src="images/marineStairs.jpg" width="100%" height="auto" />
    </div>
  </div>,
  <>
    <h4 className="slideTitle">Potential low emission fuels - Diesel</h4>
    <div className="slideContainer slide_solidColour">
      <img src="images/marineTable2.jpg" width="100%" height="auto" />
    </div>
  </>,
];
